import React from "react";
import { FlexContainer } from "src/components";
import { 
    ImageContainer,
    ImagePreview,
    InputDescription,
    TextLabel,
    ErrorMessage,
    BrowseFileButton
} from "../../style";

export const AddArticleImageField = (props) => {
    return (
        <FlexContainer>
            <TextLabel fontWeight="bold"> {props.value.quoteUuid ? "Edit" : "Add"} Article (Optional)</TextLabel>
            <TextLabel color="#000000" fontSize="16px" fontWeight="bold"
            >  Upload Article Image (Optional) </TextLabel>
            <TextLabel color="#612684" fontSize="15px" fontWeight="normal">
                Click browse file to upload your article image.
            </TextLabel>
            <ImageContainer
                height="170px"
                width="302px"
                ref={props.value.articleImageRef}
                onDrop={(file) => props.value.handleAddArticleImage(file, "articleImage")}
            >
                { (props.value.articleImage ?
                    (props.value.articleImage) && (
                        <ImagePreview src={props.value.articleImage} />
                    )
                    :
                    (props.value.renderArticleImage) && (
                        <ImagePreview src={props.value.renderArticleImage} />
                    )
                )}
                <BrowseFileButton
                    backgroundColor="#000"
                    color="#fff"
                    border="1px solid #000"
                    size="0.813rem"
                    style={{
                        borderRadius: "7px",
                        boxShadow: "none",
                        position: props.value.articleImage || props.value.renderArticleImage ? "absolute" : "relative",
                        right: props.value.articleImage || props.value.renderArticleImage ? "-180px" : undefined,
                        zIndex: 200,
                    }}
                    disabled={false}
                >
                    { props.value.articleImage || props.value.renderArticleImage ? "Change Image" : "Browse File" }
                </BrowseFileButton>
            </ImageContainer>
            <ErrorMessage>{props.error}</ErrorMessage>
            { (!props.value.articleImage || props.value.renderArticleImage) && (
                <InputDescription color="#808080" size="0.938rem" margin="15px 0 0" align="left">
                   Supported formats: JPG, PNG. <br/> Recommended size 1920px x 10806px for best display.
                </InputDescription>
            )}
        </FlexContainer>
    );
};
